import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { errText } from "@/components/pipeline/utils";

const MAIN_FIELDS = ["Nom / Prénom", "Téléphone", "E-mail", "Adresse des Travaux", "Commentaire"];

export const CreateLeadDialog = ({ open, onOpenChange, meta, pipeline, onCreated }) => {
  const blank = { title: "", pipeline: pipeline || meta.pipelines[0]?.name || "", step_id: "", user_id: meta.me.nocrm_user_id || meta.users[0]?.user_id || "", amount: "", tags: [], fields: {}, note: "" };
  const [form, setForm] = useState(blank);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setForm({ ...blank, pipeline: pipeline || blank.pipeline }); }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  const steps = meta.pipelines.find((p) => p.name === form.pipeline)?.steps || [];
  const fieldNames = MAIN_FIELDS.filter((f) => meta.fields.includes(f));
  const submit = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/pipeline/leads", {
        title: form.title, step_id: Number(form.step_id || steps[0]?.id), user_id: form.user_id ? Number(form.user_id) : null,
        amount: form.amount === "" ? null : Number(form.amount), tags: form.tags, fields: form.fields, note: form.note,
      });
      toast.success("Opportunité créée dans noCRM.");
      onCreated(data);
      onOpenChange(false);
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="pl-create" data-testid="create-opportunity-dialog">
        <DialogHeader>
          <DialogTitle>Nouvelle opportunité</DialogTitle>
          <DialogDescription>Elle est créée directement dans noCRM et apparaît tout de suite dans le pipeline.</DialogDescription>
        </DialogHeader>
        <div className="pl-create-grid">
          <label className="wide"><span>Titre *</span><input value={form.title} placeholder="Ex. Mairie - Agen" onChange={(e) => setForm({ ...form, title: e.target.value })} data-testid="create-title" /></label>
          <label><span>Pipeline</span>
            <select value={form.pipeline} onChange={(e) => setForm({ ...form, pipeline: e.target.value, step_id: "" })} data-testid="create-pipeline">{meta.pipelines.map((p) => <option key={p.name} value={p.name}>{p.name}</option>)}</select>
          </label>
          <label><span>Étape</span>
            <select value={form.step_id} onChange={(e) => setForm({ ...form, step_id: e.target.value })} data-testid="create-step">{steps.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select>
          </label>
          {meta.me.is_admin && (
            <label><span>Commercial *</span>
              <select value={form.user_id} onChange={(e) => setForm({ ...form, user_id: e.target.value })} data-testid="create-owner">{meta.users.map((u) => <option key={u.user_id} value={u.user_id}>{u.name}</option>)}</select>
            </label>
          )}
          <label><span>Montant (€)</span><input type="number" value={form.amount} onChange={(e) => setForm({ ...form, amount: e.target.value })} data-testid="create-amount" /></label>
          {fieldNames.map((f) => (
            <label key={f} className={f === "Commentaire" || f.startsWith("Adresse") ? "wide" : ""}><span>{f}</span>
              <input value={form.fields[f] || ""} onChange={(e) => setForm({ ...form, fields: { ...form.fields, [f]: e.target.value } })} data-testid={`create-field-${f.replace(/\W+/g, "-")}`} />
            </label>
          ))}
          <label className="wide"><span>Tags (séparés par des virgules)</span>
            <input list="pl-tag-options" defaultValue="" onChange={(e) => setForm({ ...form, tags: e.target.value.split(",").map((t) => t.trim()).filter(Boolean) })} data-testid="create-tags" />
          </label>
        </div>
        <DialogFooter>
          <button type="button" className="secondary-button" onClick={() => onOpenChange(false)} data-testid="create-cancel">Annuler</button>
          <button type="button" className="primary-button" disabled={busy || !form.title.trim()} onClick={submit} data-testid="create-submit">{busy ? "Création…" : "Créer l'opportunité"}</button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
